module.exports = __webpack_public_path__ + "img/ajuda.b2e33bfe.svg";